import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import './AskAI.scss';
import { useChatSession } from '../../hooks/useChatSession';
import { useChatMessages } from '../../hooks/useChatMessages';
import { useCelebration } from '../../hooks/useCelebration';
import {
  ChatHeader,
  CelebrationOverlay,
  MessageList,
  ChatInput,
  AlertMessages,
} from '../../components/Chat';

const ChatWithMe = () => {
  // Custom hooks
  const chatSession = useChatSession();
  const chatMessages = useChatMessages();
  const celebration = useCelebration();

  // Initialize chat session on component mount
  useEffect(() => {
    const initChat = async () => {
      const greeting = await chatSession.initializeChat();
      chatMessages.addInitialMessage(greeting);
    };
    initChat();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Handle sending messages
  const handleSendMessage = async () => {
    await chatMessages.sendMessage(
      chatSession.sessionId,
      chatSession.userToken,
      chatSession.updateActivity,
      chatSession.updateUserInfo,
      chatSession.updateRateLimits,
      chatSession.setError,
      celebration.triggerCelebration
    );
  };

  // Handle key press for input
  const handleKeyPress = (e) => {
    chatMessages.handleKeyPress(e, handleSendMessage);
  };

  // Character info for input
  const characterInfo = chatMessages.getCharacterInfo();
  
  // Can send message check
  const canSendMessage = chatMessages.canSendMessage(
    chatSession.sessionId,
    chatSession.userToken,
    chatSession.rateLimits
  );

    return (
    <div className="app__ask-ai">
      <motion.div
        className="app__ask-ai-container"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <ChatHeader userInfo={chatSession.userInfo} />
        
        <AlertMessages 
          warning={chatSession.warning} 
          error={chatSession.error} 
        />

        <CelebrationOverlay 
          showCelebration={celebration.showCelebration}
          userName={chatSession.userInfo.name}
        />

        <div className="app__ask-ai-chat">
          <MessageList
            messages={chatMessages.messages}
            isTyping={chatMessages.isTyping}
            isInitializing={chatSession.isInitializing}
            userInfo={chatSession.userInfo}
            messagesEndRef={chatMessages.messagesEndRef}
          />

          <ChatInput
            inputText={chatMessages.inputText}
            inputRef={chatMessages.inputRef}
            onInputChange={chatMessages.handleInputChange}
            onKeyPress={handleKeyPress}
            onSendMessage={handleSendMessage}
            onSuggestionClick={chatMessages.handleSuggestionClick}
            canSendMessage={canSendMessage}
            sessionId={chatSession.sessionId}
            userToken={chatSession.userToken}
            rateLimits={chatSession.rateLimits}
            isTyping={chatMessages.isTyping}
            characterInfo={characterInfo}
            messages={chatMessages.messages}
            isInitializing={chatSession.isInitializing}
          />
        </div>
      </motion.div>
    </div>
  );
};

export default ChatWithMe;